<template>
  <div :class="$style.container" style="
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      height: 100%;
    " v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="loginFormLk" style="
        width: 400px;
        border: 1px solid transparent;
        padding: 0;
        margin-top: -50px;
      ">
      <el-row>
        <p style="color: #3998f7; font-size: 30px; margin-bottom: 25px">
          {{ TITLE }}
        </p>
        <p style="
            color: #5e696f;
            font-size: 16px;
            margin-top: 0;
            margin-bottom: 20px;
          ">

        </p>
      </el-row>
      <el-row>
        <el-tabs style="font-size: 20px" v-model="activeNameTab" stretch @tab-click="handleClickTab">
          <el-tab-pane v-if="isShowQRCode" label="扫码登录" name="code">
            <canvas ref="qrcode" id="myCanvasLoginQrCode" style="margin-top: 10px" :class="$style.img"></canvas>
            <div :class="$style.btn">
              <el-button type="warning" @click.stop="handleRefreshCode" size="small" :disabled="refresh">刷新二维码
              </el-button>
            </div>
            <p style="
                font-size: 16px;
                margin-top: 25px;
                color: #5e696f;
                line-height: 24px;
              ">
              {{ title }}
            </p>
          </el-tab-pane>
          <el-tab-pane v-if="isShowPassword" style="font-size: 20px" label="账户密码登录" name="user">
            <el-form :rules="rules" autocomplete="new-password" style="margin-top: 10px" ref="ruleFormUser"
              class="demo-ruleForm" :model="form">
              <el-form-item prop="username" class="textSty">
                <el-input v-model="form.username" autocomplete="off" placeholder="请输入用户名">
                  <i slot="prefix" class="el-input__icon" style="
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 45px;
                    ">
                    <img src="../assets/images/username.png" height="20" alt="" />
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="password" class="textSty">
                <el-input v-model="form.password" autocomplete="new-password" type="password" placeholder="请输入密码">
                  <i slot="prefix" class="el-input__icon" style="
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 45px;
                    ">
                    <img src="../assets/images/password.png" height="20" alt="" />
                  </i>
                </el-input>
              </el-form-item>
            </el-form>
            <span style="
                margin: -12px 0 20px 0px;
                float: right;
                font-size: 12px;
                color: #ff9901;
                cursor: pointer;
              " @click="dialogLk">忘记密码</span>
            <el-row>
              <el-button type="primary" style="width: 100%" @click="login3">立即登录</el-button>
            </el-row>
          </el-tab-pane>
          <el-tab-pane v-if="isShowPhone" label="手机号登录" name="phone">
            <el-form :rules="rules" ref="ruleFormPhone" style="margin-top: 10px" class="demo-ruleForm" :model="form">
              <el-form-item prop="phone" class="textSty">
                <el-input v-model="form.phone" autocomplete="off" @input="getTenants('login')" placeholder="请输入手机号">
                  <i slot="prefix" class="el-input__icon" style="
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 45px;
                    ">
                    <img src="../assets/images/phoneLogin.png" height="24" alt="" />
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="verifyCode" class="verifyCode">
                <el-input v-model="form.verifyCode" type="text" autocomplete="off" style="flex-grow: 1"
                  placeholder="请输入验证码">
                  <i slot="prefix" class="el-input__icon" style="
                      display: inline-flex;
                      align-items: center;
                      justify-content: center;
                      width: 45px;
                    ">
                    <img src="../assets/images/verifyCode.png" height="15" alt="" />
                  </i>
                </el-input>
                <el-button type="primary" style="
                    flex-shrink: 0;
                    margin-left: 10px;
                  " :disabled="VerificationText === 0 ? false : true" @click="sendVerification('login')">
                  {{ VerificationText === 0 ? '获取验证码' : VerificationText + '秒' }}
                </el-button>
              </el-form-item>
              <!--                            <el-form-item v-if="tenants.length>1" prop="tenant_id">-->
              <!--                                <el-select style="width: 100%" v-model="form.tenant_id" placeholder="请选择租户">-->
              <!--                                    <el-option-->
              <!--                                            v-for="item in tenants"-->
              <!--                                            :key="item.tenant_id"-->
              <!--                                            :label="item.tenant_name"-->
              <!--                                            :value="item.tenant_id">-->
              <!--                                    </el-option>-->
              <!--                                </el-select>-->
              <!--                            </el-form-item>-->
            </el-form>
            <!--                        <span style="margin: -12px 0 20px 0px;float: right;font-size: 12px;color: #FF9901;cursor:pointer"-->
            <!--                              @click="dialogLk">忘记密码</span>-->
            <el-row>
              <el-button type="primary" style="width: 100%" @click="login2">立即登录</el-button>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row style="margin-top: 40px; font-size: 15px" v-if="(MobileUrl.iOS || MobileUrl.Android) && DOWNLOAD">
        <span style="color: #303133">客户端App下载</span>
        &nbsp;
        <a :href="MobileUrl.iOS" v-if="MobileUrl.iOS" target="_blank" style="color: #409eff">iOS</a>
        &nbsp;
        <a :href="MobileUrl.Android" target="_blank" v-if="MobileUrl.Android" style="color: #409eff">Android</a>
      </el-row>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="700px" :show-close="false" @close="dialogClose"
      style="vertical-align: center; :#FFF9F3 " custom-class="dialogSty">
      <div style="margin-top: -40px" class="dialogLoginReset">
        <el-row>
          <el-col :span="12">
            <div style="
                color: #3998f7;
                padding-top: 8px;
                font-size: 20px;
                text-align: left;
              ">
              重置登录密码
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="danger" size="small" @click="dialogVisible = false">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px; height: 400px; position: relative">
          <el-steps :active="active" simple finish-status="wait">
            <el-step title="选择方式" icon="el-icon-edit" style="font-size: 14px">
              <template slot="icon">
                <span style="font-size: 16px">①</span>
              </template>
            </el-step>
            <el-step title="发送验证码" icon="el-icon-upload" style="font-size: 14px">
              <template slot="icon">
                <span style="font-size: 16px">②</span>
              </template>
            </el-step>
            <el-step title="修改密码" icon="el-icon-picture" style="font-size: 14px">
              <template slot="icon">
                <span style="font-size: 16px">③</span>
              </template>
            </el-step>
            <el-step title="完成" icon="el-icon-picture" style="font-size: 14px">
              <template slot="icon">
                <span style="font-size: 16px">④</span>
              </template>
            </el-step>
          </el-steps>

          <div v-if="active == 0">
            <div>
              <div @click="selectBack('phone')" :style="{
                  backgroundColor: myType == 'phone' ? '#ECF3FC' : '#fff',
                  borderColor: myType == 'phone' ? '#4A90E2' : '#ededed',
                }" class="boxSty">
                <div style="width: 80px">
                  <img src="../assets/images/shouji.png" alt="" style="width: 33px; height: 50px; margin-left: 20px" />
                </div>
                <div>
                  <p style="
                      color: #3998f7;
                      font-size: 21px;
                      text-align: left;
                      padding-left: 15px;
                      margin-bottom: 0;
                    ">
                    通过手机短信验证码
                  </p>
                  <p style="
                      color: #4a4a4a;
                      font-size: 12px;
                      text-align: left;
                      padding: 0 15px 15px 15px;
                      margin-top: 17px;
                    ">
                    向用户绑定的手机号码发送短信验证码来验证身份
                  </p>
                </div>
              </div>

              <div @click="selectBack('email')" :style="{
                  backgroundColor: myType == 'email' ? '#ECF3FC' : '#fff',
                  borderColor: myType == 'email' ? '#4A90E2' : '#ededed',
                }" class="boxSty">
                <div style="width: 80px">
                  <img src="../assets/images/you1.png" alt="" style="width: 48px; margin-left: 20px" />
                </div>
                <div>
                  <p style="
                      color: #3998f7;
                      font-size: 21px;
                      text-align: left;
                      padding-left: 15px;
                      margin-bottom: 2px;
                    ">
                    通过邮件发送验证码
                  </p>
                  <p style="
                      color: #4a4a4a;
                      font-size: 12px;
                      text-align: left;
                      padding: 0 15px 15px 15px;
                      margin-top: 17px;
                    ">
                    向用户绑定的电子邮件地址发送验证码来验证身份
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="active == 1">
            <div style="margin-top: 100px">
              <el-form :inline="true" ref="rulesVerification" size="small" :hide-required-asterisk="true"
                label-width="70px" class="demo-ruleForm demo-form-inline" :rules="rulesVerification"
                :model="formVerification">
                <el-form-item v-if="myType === 'phone'" style="position: relative" label="手机号码" prop="phone"
                  class="textSty">
                  <el-input v-model="formVerification.phone" autocomplete="off" @input="getTenants"
                    placeholder="请输入绑定手号码" style="width: 260px"></el-input>
                  <el-button type="primary" style="margin-left: 10px; width: 100px" size="small"
                    :disabled="VerificationText === 0 ? false : true" @click="sendVerification('')">
                    {{ VerificationText === 0 ? '发送验证码' : VerificationText + '秒' }}
                  </el-button>
                  <span v-if="VerificationText !== 0" style="
                      font-size: 12px;
                      color: #7ed321;
                      position: absolute;
                      left: 2px;
                      bottom: -25px;
                    ">验证码已发送!</span>
                </el-form-item>
                <el-form-item v-if="myType === 'phone'" style="position: relative" label="验 证 码" class="textSty">
                  <el-input type="number" v-model="formCaptcha.validation" autocomplete="off" placeholder="请输入验证码"
                    style="width: 260px"></el-input>

                  <el-button type="primary" style="margin-left: 10px; width: 100px; visibility: hidden" size="small">
                    {{ VerificationText === 0 ? '发送验证码' : VerificationText + '秒' }}
                  </el-button>
                </el-form-item>

                <el-form-item v-if="myType === 'email'" label="电子邮件" style="position: relative" prop="email"
                  class="textSty">
                  <el-input v-model="formVerification.email" autocomplete="off" @input="getTenantsEmail"
                    placeholder="请输入绑定电子邮件地址" style="width: 260px"></el-input>
                  <el-button type="primary" size="small" :disabled="VerificationText === 0 ? false : true"
                    style="width: 100px; margin-left: 10px" @click="sendVerification('')">
                    {{ VerificationText === 0 ? '发送验证码' : VerificationText + '秒' }}
                  </el-button>
                  <span v-if="VerificationText !== 0" style="
                      font-size: 12px;
                      color: #7ed321;
                      position: absolute;
                      left: 2px;
                      bottom: -25px;
                    ">验证码已发送!</span>
                </el-form-item>

                <el-form-item v-if="myType === 'email'" style="position: relative" label="验 证 码" class="textSty">
                  <el-input type="number" v-model="formCaptcha.validation" autocomplete="off" placeholder="请输入验证码"
                    style="width: 260px"></el-input>

                  <el-button type="primary" style="margin-left: 10px; width: 100px; visibility: hidden" size="small">
                    {{ VerificationText === 0 ? '发送验证码' : VerificationText + '秒' }}
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div v-if="active == 2">
            <div style="margin-top: 70px">
              <el-form :model="formCaptcha" :rules="rulesCaptcha" status-icon ref="formCaptcha" label-width="100px"
                size="small" :hide-required-asterisk="true" class="demo-ruleForm">
                <!--                                <el-row>-->
                <!--                                    <el-col :span="12" :offset="6">-->
                <!--                                        <el-form-item label="验 证 码" prop="validation" class="textSty">-->
                <!--                                            <el-input type="number" v-model="formCaptcha.validation" autocomplete="off"-->
                <!--                                                      placeholder="请输入验证码"></el-input>-->
                <!--                                        </el-form-item>-->
                <!--                                    </el-col>-->
                <!--                                </el-row>-->
                <el-row>
                  <el-col :span="12" :offset="6">
                    <el-form-item v-if="tenants.length > 1" label="租户" prop="tenant_id" class="textSty">
                      <el-select style="width: 100%" v-model="formCaptcha.tenant_id" placeholder="请选择租户">
                        <el-option v-for="item in tenants" :key="item.tenant_id" :label="item.tenant_name"
                          :value="item.tenant_id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" :offset="6">
                    <el-form-item label="新 密 码" prop="pass" class="textSty">
                      <el-input type="password" v-model="formCaptcha.pass" autocomplete="off" placeholder="新 密 码">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" :offset="6">
                    <el-form-item label="确认密码" prop="checkPass" class="textSty">
                      <el-input type="password" v-model="formCaptcha.checkPass" autocomplete="off" placeholder="确认密码">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
          <div v-if="active == 3">
            <div style="margin-top: 60px">
              <img src="../assets/images/gou.png" alt="" style="width: 100px; height: 100px" />
              <p style="color: #ff9900; font-size: 16px; margin-top: 40px">
                密码重置成功，请使用新的密码登入系统
              </p>
            </div>
          </div>
          <div style="
              border-top: 2px dotted #e7eaec;
              position: absolute;
              bottom: 0%;
              width: 100%;
            ">
            <el-button style="margin-top: 12px; float: left" size="small" type="warning" @click="prev"
              v-if="active == 1 || active == 2">
              上一步
            </el-button>
            <el-button style="margin-top: 12px; float: right" size="small" :type="active == 2 ? 'primary' : 'warning'"
              @click="next" v-if="active == 0 || active == 1 || active == 2">{{ active == 2 ? '修改密码' : '下一步' }}
            </el-button>
            <el-button style="margin-top: 12px; float: right" size="small" type="success" @click="onComplete"
              v-show="active == 3">完成
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--       登录选择租户-->
    <el-dialog :visible.sync="dialogSelectTenant" width="700px" :show-close="false"
      style="vertical-align: center; :#FFF9F3 " custom-class="dialogSty">
      <div style="margin-top: -40px" class="dialogLoginReset">
        <el-row>
          <el-col :span="12">
            <div style="
                color: #3998f7;
                padding-top: 8px;
                font-size: 20px;
                text-align: left;
              ">
              选择租户
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="danger" size="small" @click="dialogSelectTenant = false">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div style="
            margin-top: 20px;
            height: 400px;
            position: relative;
            text-align: left;
            overflow: auto;
          ">
          <div v-for="(item, index) in tenants" :key="index" style="width: 60%; margin: 20px auto; overflow: hidden">
            <p style="
                width: 300px;
                display: inline-block;
                overflow: hidden;
                word-wrap: break-word;
                word-break: normal;
                text-overflow: ellipsis;
                white-space: nowrap;
              ">
              {{ item.tenant_name }}
            </p>
            <el-button type="primary" size="small" style="float: right; margin-top: 5px" @click="onIntoThe(item)">
              立即进入
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import QRCode from 'qrcode'
  import http from '../APIService/http'
  import io from 'socket.io-client'
  import VueAMap from 'vue-amap'
  import { bus } from '../router/index.js'

  export default {
    data() {
      let that = this
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (that.formCaptcha.checkPass !== '') {
            that.$refs.formCaptcha.validateField('checkPass')
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== that.formCaptcha.pass) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        MobileUrl: {
          iOS: '',
          Android: '',
        },
        isShowQRCode: true,
        isShowPassword: true,
        isShowPhone: true,
        loading: false,
        tenants: [],
        activeNameTab: 'code',
        myType: 'phone',
        title: '请打开App，进入“管理”模块，点击右上角的“扫码”图标，扫码登录',
        obj: {},
        id: '',
        refresh: false,
        list: [],
        activeName: '',
        serverName: '',
        form: {
          username: '',
          password: '',
          phone: '',
          verifyCode: '',
          tenant_id: '',
        },
        rules: {
          username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          tenant_id: [{ required: true, message: '请选择租户', trigger: 'change' }],
          // verifyCode: [
          //   {required: true, message: '请输入验证码', trigger: 'blur'}
          // ]
        },
        uuidA: '',
        VerificationText: 0,
        formVerification: {
          phone: '',
          email: '',
        },
        rulesVerification: {
          phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          email: [{ required: true, message: '请输入电子邮件地址', trigger: 'blur' }],
          validation: [{ required: true, message: '请输入接收到的验证码', trigger: 'blur' }],
        },
        formCaptcha: {
          validation: '',
          tenant_id: '',
          pass: '',
          checkPass: '',
        },
        rulesCaptcha: {
          validation: [{ required: true, message: '请输入接收到的验证码', trigger: 'blur' }],
          tenant_id: [{ required: true, message: '请选择租户', trigger: 'change' }],
          pass: [{ validator: validatePass, trigger: 'blur' }],
          checkPass: [{ validator: validatePass2, trigger: 'blur' }],
        },
        formLabelAlign: {
          name: '',
          region: '',
          phone: '',
          validation: '',
          pass: '',
          checkPass: '',
        },
        dialogVisible: false,
        active: 0,
        dialogSelectTenant: false,
        SelectTenantType: '',
        seatsocket: null,
        TITLE: '',
        DOWNLOAD: false,
        LOGO: '',
      }
    },

    created() {
      this.getYPSystemInfo()
      this.getMobileUrl()
      this.getTerritoryList()
      // this.getParametersInfo()

      sessionStorage.clear()

      this.$store.commit('resetUser')
      this.$store.commit('resetStore')
      this.$store.commit('resetInspection')
      this.$store.commit('resetListServiceSheet')
      this.$store.commit('resetRadio')
      this.$store.commit('resetPage1')
      this.$store.commit('resetPage2')
      this.$store.commit('resetPage3')
      this.$store.commit('resetRadio2')
      this.$store.commit('resetData')
      this.$store.commit('resetJuData')
      this.$store.commit('resetParameters')

      //判断是否为IE浏览器
      let mb = this.myBrowser()
      if (mb === 'IE') {
        this.title = '抱歉！暂不支持IE浏览器的访问，请使用Chrome等浏览器进行访问'
        this.refresh = true
      } else {
        this.socket()
      }
    },
    mounted() {
      //
      // var canvas = document.getElementById('myCanvasLoginQrCode');
      // var gl = canvas.getContext('webgl2');
    },
    methods: {
      async getYPSystemInfo() {
        try {
          let user = this.$store.getters.getUser
          let data = {
            product_version: '0.1.0',
            product_id: 'CRM',
          }
          debugger;
          await http.post('/yp/parameters/getParametersList', data).then((res) => {
            debugger
            if (res.success == true) {
              let amapKey = "";
              let amapSecurityJsCode = "";
              //编写信息
              for (let i in res.data) {
                if (res.data[i].parameter_id == 'SYSTEM_TITLE') {
                  this.TITLE = res.data[i].parameter_value
                  localStorage.setItem('system_title', res.data[i].parameter_value);
                } else if (res.data[i].parameter_id == 'SYSTEM_WEB_LOGO') {
                  this.LOGO = res.data[i].parameter_value
                } else if (res.data[i].parameter_id == 'ENABLE_LOGIN_APP_DOWNLOAD') {
                  debugger;
                  this.DOWNLOAD = res.data[i].parameter_value == 'T' ? true : false
                } else if (res.data[i].parameter_id == 'AMAP_JSAPI_KEY') {
                  amapKey = res.data[i].parameter_value
                  localStorage.setItem('AMAP_JSAPI_KEY', res.data[i].parameter_value);
                } else if (res.data[i].parameter_id == 'AMAP_JSAPI_SECURITY') {
                  amapSecurityJsCode = res.data[i].parameter_value
                  localStorage.setItem('AMAP_JSAPI_SECURITY', res.data[i].parameter_value);
                } else if (res.data[i].parameter_id == 'ENABLE_LOGIN_BY_QRCODE') {
                  this.isShowQRCode = res.data[i].parameter_value == "T" ? true : false;
                } else if (res.data[i].parameter_id == 'ENABLE_LOGIN_BY_PASSWORD') {
                  this.isShowPassword = res.data[i].parameter_value == "T" ? true : false;
                } else if (res.data[i].parameter_id == 'ENABLE_LOGIN_BY_SMS') {
                  this.isShowPhone = res.data[i].parameter_value == "T" ? true : false;
                }
              }

              if (this.isShowQRCode) {
                this.activeNameTab = 'code'
              }else  if (this.isShowPassword) {
                this.activeNameTab = 'user'
              }else if (this.isShowPhone) {
                this.activeNameTab = 'phone'
              }else{
                this.activeNameTab = ''
              }

              if (amapKey != "" && amapSecurityJsCode != "") {
                window._AMapSecurityConfig = {
                  securityJsCode: amapSecurityJsCode,
                }
                VueAMap.initAMapApiLoader({
                  key: amapKey,
                  // key:store.getters.getParameters.find(e=>e.parameter_id=="CRM_GAODE_KEY").parameter_value,
                  plugin: ['AMap.Autocomplete',
                    'AMap.PlaceSearch',
                    'AMap.Scale',
                    'AMap.OverView',
                    'AMap.ToolBar',
                    'AMap.MapType',
                    'AMap.Driving',
                    'AMap.InfoWindow',
                    'AMap.MarkerClusterer',
                    'AMap.PolyEditor',
                    'AMap.CircleEditor',
                    "AMap.Geolocation"], //定位控件
                  // 默认高德 sdk 版本为 1.4.4
                  // v: '1.4.4',
                  uiVersion: '1.0' // 版本号
                })
              }
            }
          })
        } catch (e) { }
      },
      // getParametersInfo() {
      //   try {
      //     let user = this.$store.getters.getUser
      //     let data = {
      //       product_version: '0.1.0',
      //       product_id: 'CRM',
      //     }
      //     http.post('/yp/parameters/getLOGINBYQRCODE', data).then((res) => {
      //       if (res.success == true) {
      //         this.isShowQRCode = res.data
      //         // this.isShowQRCode=false;
      //         if (!this.isShowQRCode && this.isShowQRCode) {
      //           this.activeNameTab = 'user'
      //         } else {
      //           this.activeNameTab = 'phone'
      //         }
      //         // this.territoryList = res.data
      //         // localStorage.setItem('territoryList',JSON.stringify(this.territoryList))
      //       }
      //     })
      //   } catch (e) { }
      // },
      getParametersList() {
        try {
          let user = this.$store.getters.getUser
          let data = {
            tenant_id: user.tenant_id
          }
          http.post('/crm/other/parameters/getAllByTenantId', data).then((res) => {
            console.log("-----------------------------")
            debugger;
            console.log(res);
            this.$store.commit('setParameters', res.data)
          })
        } catch (e) { }
      },
      getTerritoryList() {
        try {
          let user = this.$store.getters.getUser
          let data = {
            tenant_id: user.tenant_id,
            user_id: user.user_id,
          }
          http.post('/wapi/Collect/getTerritoryList', data).then((res) => {
            if (res.success == true) {
              this.territoryList = res.data
              localStorage.setItem('territoryList', JSON.stringify(this.territoryList))
            }
          })
        } catch (e) { }
      },
      async getMobileUrl() {
        let res = await http.post('/yp/other/getMobileUrl')
        debugger
        if (res.data) {
          this.MobileUrl = res.data
        }
      },
      myBrowser() {
        //取得浏览器的userAgent字符串
        let userAgent = navigator.userAgent
        //判断是否Opera浏览器
        let isOpera = userAgent.indexOf('Opera') > -1
        if (isOpera) {
          return 'Opera'
        }
        //判断是否Firefox浏览器
        if (userAgent.indexOf('Firefox') > -1) {
          return 'FF'
        }

        if (userAgent.indexOf('Chrome') > -1) {
          return 'Chrome'
        }
        //判断是否Safari浏览器
        if (userAgent.indexOf('Safari') > -1) {
          return 'Safari'
        }
        //判断是否IE浏览器
        if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
          return 'IE'
        }
        return '其他'
      },

      async login(userObj) {
        try {
          this.obj = userObj
          console.log("---------------")
console.log(userObj)
          if (this.obj.tenant_type && this.obj.tenant_type === 'CRM') {
            if (this.obj.role === 'clerk') {
              //clerk、manager、staff、admin
              this.error('抱歉！目前仅支持管理人员登录')
              this.socket()
              this.loading = false
              return
            }

            let res = await http.post('/wapi/v1/scanTheCodeLogin', this.obj)
            if (!res.success) {
              this.socket()
              this.$message.error(res.msg)
              this.loading = false
              return
            }

            this.$store.commit('setUser', userObj)
            this.rolePage(userObj)
            this.LoginRecord(userObj) //登录记录
            var obj = { index: true }
            this.$store.commit('setStoreChange', obj)
            this.seatsocket && this.seatsocket.close()

            //5天主动退出
            // setTimeout(this.pageExit, 432000 * 1000);
          } else {
            this.error('请使用“CRM”App扫码')
          }
        } catch (err) {
          this.error('登录失败')
        }
      },
      async login2() {
        try {
          let rule
          this.$refs[this.activeNameTab === 'phone' ? 'ruleFormPhone' : 'ruleFormUser'].validate((valid) => {
            if (valid) {
              rule = true
            } else {
              rule = false
              return false
            }
          })
          if (!rule) {
            return
          }
          let userObj
          let data = {}
          if (this.activeNameTab === 'phone') {
            let CaptchaRes = await this.loginVerifyCaptcha()
            if (!CaptchaRes) {
              return false
            }
            data = {
              phone: this.form.phone || '',
              verifyCode: this.form.verifyCode || '',
              tenant_id: this.form.tenant_id || '',
            }

            //如果用户租户数据大于1 则让用户选择弹窗选择租户
            if (this.tenants && this.tenants.length > 1) {
              this.dialogSelectTenant = true
              this.SelectTenantType = 'phone'
              return
            }
          } else {
            let UserRes = await http.post('/oauth/verifyUserName', {
              username: this.form.username,
              product_id: 'CRM',
              tenant_type: 'CRM',
            })
            if (!UserRes.success) {
              this.$message.error(UserRes.message)
              return false
            }
            data = {
              username: this.form.username || '',
              password: this.form.password || '',
              // tenant_id: UserRes.data || '',
              tenant_id: this.form.tenant_id || '',
            }
            //如果用户租户数据大于1 则让用户选择弹窗选择租户
            if (this.tenants && this.tenants.length > 1) {
              this.dialogSelectTenant = true
              this.SelectTenantType = 'username'
              return
            }
          }
          this.loading = true
          let res = await http.post('/wapi/v1/login', data)
          //console.log(res);

          if (res.success) {
            this.obj = userObj = res.data
            this.seatsocket && this.seatsocket.close()
          } else {
            this.loading = false
            this.$message.error(res.msg)
            return
          }

          if (this.obj.tenant_type && this.obj.tenant_type === 'CRM') {
            // if (this.obj.role === 'clerk') {//clerk、manager、staff、admin
            //     this.error('抱歉！目前仅支持管理人员登录')
            //     this.socket()
            //     return
            // }
            this.$store.commit('setUser', userObj)
            this.rolePage(userObj)
            this.LoginRecord(userObj) // 登录记录
            var obj = { index: true }
            this.$store.commit('setStoreChange', obj)

            // 5天主动退出
            // setTimeout(this.pageExit, 432000 * 1000);
          } else {
            this.loading = false
            this.$message.error('用户名或密码错误')
          }
        } catch (err) {
          this.loading = false
          this.error('登录失败')
        }
      },
      login3() {
        this.getTenantsLogin('username')
      },

      async userLogin3() {
        debugger;
        try {
          //console.log(this.form.tenant_id,2)
          let rule
          this.$refs[this.activeNameTab === 'phone' ? 'ruleFormPhone' : 'ruleFormUser'].validate((valid) => {
            if (valid) {
              rule = true
            } else {
              rule = false
              return false
            }
          })
          if (!rule) {
            return
          }
          let userObj
          let data = {}
          if (this.activeNameTab === 'phone') {
            let CaptchaRes = await this.loginVerifyCaptcha()
            if (!CaptchaRes) {
              return false
            }
            data = {
              phone: this.form.phone || '',
              verifyCode: this.form.verifyCode || '',
              tenant_id: this.form.tenant_id || '',
            }

            //如果用户租户数据大于1 则让用户选择弹窗选择租户
            if (this.tenants && this.tenants.length > 1) {
              this.dialogSelectTenant = true
              this.SelectTenantType = 'phone'
              return
            }
          } else {
            let UserRes = await http.post('/oauth/verifyUserName', {
              username: this.form.username,
              product_id: 'CRM',
              tenant_type: 'CRM',
            })
            if (!UserRes.success) {
              this.$message.error(UserRes.message)
              return false
            }
            data = {
              username: this.form.username || '',
              password: this.form.password || '',
              // tenant_id: UserRes.data || '',
              tenant_id: this.form.tenant_id || '',
            }
            //如果用户租户数据大于1 则让用户选择弹窗选择租户
            if (this.tenants && this.tenants.length > 1) {
              this.dialogSelectTenant = true
              this.SelectTenantType = 'username'
              return
            }
          }
          this.loading = true
          let res = await http.post('/wapi/v1/login', data)
          //console.log(res);

          if (res.success) {
            this.obj = userObj = res.data
          } else {
            this.loading = false
            this.$message.error(res.msg)
            return
          }
          debugger;
          if (this.obj.tenant_type && this.obj.tenant_type === 'CRM') {
            // if (this.obj.role === 'clerk') {//clerk、manager、staff、admin
            //     this.error('抱歉！目前仅支持管理人员登录')
            //     this.socket()
            //     return
            // }
            this.$store.commit('setUser', userObj)
            this.rolePage(userObj)
            this.LoginRecord(userObj) // 登录记录
            var obj = { index: true }
            this.$store.commit('setStoreChange', obj)

            // 5天主动退出
            // setTimeout(this.pageExit, 432000 * 1000);
          } else {
            this.loading = false
            this.$message.error('用户名或密码错误')
          }
        } catch (err) {
          this.loading = false
          this.error('登录失败')
        }
      },
      // 二维码
      socket() {
        //调用之前先关闭 否则每次刷新二维码都会调用多次登录函数
        if (this.seatsocket) {
          this.seatsocket.close()
        }

        localStorage.setItem('active', 1)
        // this.serverName = "10.206.160.228";
        // this.serverName = "124.71.198.130";
        // this.serverName = "xndb.gykghb.com";
        // this.seatsocket = io('https://' + this.serverName + ':17002')
        // this.serverName = "10.51.248.130";

        // this.serverName = "119.3.154.73";
        // this.serverName = "cn6.saasyun.com";
        // target: 'https://cn6.saasyun.com:9000',

        // this.serverName = "app.czzyc.com";
        // this.serverName = 'cn4.saasyun.com'
        // this.serverName = 'cn5.saasyun.com'
        
        // this.serverName = 'cn3.saasyun.com'
        // this.seatsocket = io('https://' + this.serverName + ':17002')

        // this.serverName = 'webapp.saasyun.com'
        // this.seatsocket = io('https://' + this.serverName + ':17002')

         this.serverName = 'fxpc1.gyao511.com'
         this.seatsocket = io('https://' + this.serverName + ':17001')
        // this.seatsocket = io("https://cn6.saasyun.com:17002");
        // this.seatsocket = io("https://cn3.saasyun.com:17002");

        this.seatsocket.on('connect', (val) => {
          this.id = this.seatsocket.id
          this.generatorQrcode()
        })
        this.seatsocket.on('login', (value) => {
          if (value.socketId === this.id) {
            this.login(value)
          } else {
            //console.log("不是自己");
          }
        })

        if (this.id) {
          this.generatorQrcode()
        }
      },
      // 生成二维码
      generatorQrcode() {
        QRCode.toCanvas(this.$refs.qrcode, this.id + '|' + this.serverName, function (error) {
          if (error) console.error(error)
          //console.log("success!");
        })
      },
      // 点击刷新
      handleRefreshCode() {
        //                  let o = `{"user_id":"9248802127","username":"2059087476","alias":"CRM测试","role":"manager","tenant_id":"4747530849"}`
        //                  let o =`{"user_id":"4365815569","username":"2333874131","tenant_id":"2189100436","client_secret":"","client_id":"","role":"admin","alias":"bryce"}`//bryce
        //                  let o = `{"user_id":"9110001248","username":"8575412749","tenant_id":"3922856160","role":"manager","alias":"黄誉玮"}`//
        //                 let o =`{"user_id":"4863024187","username":"8575412749","tenant_id":"2189100436","role":"staff","alias":"黄誉玮"}`// 黄誉玮 sasiyun
        //                   let o = `{"user_id":"6341073518","username":"3836252633","tenant_id":"2189100436","client_secret":"","client_id":"","alias":"杜杰","role":"admin"}`//杜杰
        //                  let o = `{"user_id":"3523084108","username":"8888467159","tenant_id":"2189100436","alias":"王晓云","role":"staff"}`//王晓云
        // let o = `{"user_id":"2734186756","username":"3518561763","tenant_id":"3922856160","alias":"测试","role":"staff"}`//
        //  let o = `{"user_id":"6157857116","username":"8622586681","tenant_id":"2189100436","alias":"罗健","role":"admin"}`//
        // let o = `{"user_id":"7245172456","username":"4229420419","tenant_id":"2189100436","alias":"张霆","role":"staff"}`//
        // let o = `{"user_id":"5346148027","username":"6727768476","tenant_id":"2189100436","alias":"宋测试","role":"staff"}`//
        // let o = `{"user_id":"3673506722","username":"4738861811","tenant_id":"2189100436","alias":"宋玲玲","role":"manager"}`//
        // let o = `{"user_id":"8440254077","username":"8151822234","tenant_id":"7316731785","alias":"新","role":"manager"}`//
        // let o = `{"user_id":"6471265495","username":"7251349601","tenant_id":"2189100436","alias":"王开宇","role":"staff"}`//
        // let o = `{"user_id":"9383717455","username":"6477141908","tenant_id":"4455247243","alias":"小芳","role":"admin"}`//
        // let o = `{"user_id":"6152327673","username":"8024050444","tenant_id":"1472813522","alias":"宋玲玲","role":"admin"}`//
        // let o = `{"user_id":"7347058253","username":"9397332287","tenant_id":"1472813521","alias":"闻婷婷","role":"staff"}`//
        // let o = `{"user_id":"9097753120","username":"","tenant_id":"1472813521","alias":"闻婷婷","role":"staff"}`//
        // //
        //                    this.$store.commit('setUser', o)
        //                    var obj = {index: true}
        //                    this.$store.commit('setStoreChange', obj)
        //                    this.rolePage(JSON.parse(o))
        // // //                  this.$store.commit('setUser', o)
        // // //                  var obj = {index: true}
        // // //                  this.$store.commit('setStoreChange', obj)
        // // //                  this.rolePage(JSON.parse(o))
        // //                    this.$store.commit('setUser', o)
        // //                    var obj = {index: true}
        // //                    this.$store.commit('setStoreChange', obj)
        // //                    this.rolePage(JSON.parse(o))
        this.socket()
      },
      async rolePage(data) {
        this.loading = true
        await http
          .post('/wapi/v1/navHeader', data)
          .then((res) => {
            if (res.data.length > 0) {
              // res.data.forEach(item => {
              //     item.children=[]
              //     this.list.push(item)
              // })
              this.getShow(data).then((r) => {
                this.list = res.data
                this.list.sort((a, b) => {
                  return a.sort - b.sort
                })
                bus.$emit('navRole', this.list)
                this.loading = false
                this.changeActiveName(this.list)
              })
            } else {
              this.loading = false
              this.$message({
                type: 'error',
                message: '无权访问，请联系管理员授权',
              })
            }
          })
          .catch((err) => {
            this.loading = false
          })
      },
      appInfo() {
        var browser = { appname: 'unknown', version: 0, engine: 'unknown' },
          userAgent = window.navigator.userAgent.toLowerCase() // 使用navigator.userAgent来判断浏览器类型

        //msie,firefox,opera,chrome,netscape
        if (/(msie|firefox|opera|chrome|netscape)\D+(\d[\d.]*)/.test(userAgent)) {
          browser.appname = RegExp.$1
          browser.version = RegExp.$2
        } else if (/version\D+(\d[\d.]*).*safari/.test(userAgent)) {
          // safari
          browser.appname = 'safari'
          let Agent_s = window.navigator.userAgent
          let REGSTR_SAF = /version\/[\d.]+/gi
          let arr = []
          // arr.push(userAgent.match(REGSTR_SAF)[0].split('/')[0]);
          arr.push(Agent_s.match(REGSTR_SAF)[0].split('/')[1])
          browser.version = arr[0]
        }

        var u = navigator.userAgent
        if (u.indexOf('Trident') > -1) {
          browser.engine = 'Trident'
        } else if (u.indexOf('Presto') > -1) {
          browser.engine = 'Blink'
        } else if (u.indexOf('AppleWebKit') > -1) {
          browser.engine = 'Webkit'
        } else if (u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1) {
          browser.engine = 'Gecko'
        }
        return browser
      },
      async LoginRecord(data) {
        var testBrowser = this.appInfo()
        var sysInfo = this.getSysInfo()
        data.browser_name = testBrowser.appname
        data.browser_version = testBrowser.version
        data.browser_engine = testBrowser.engine
        data.device_type = sysInfo.device_type
        data.device_os = sysInfo.device_os
        data.os_version = sysInfo.os_version

        await http.post('/wapi/v1/LoginRecord', data).then((res) => {
          if (res.success === true) {
            //console.log("已记录登录信息!");
          }
        })
      },
      getSysInfo() {
        var userAgent = navigator.userAgent.toLowerCase()
        var device_type = 'Unknown'
        var device_os = 'Unknown'
        var os_version = 'Unknown'
        if (userAgent.indexOf('win') > -1) {
          device_type = 'Windows'
          if (userAgent.indexOf('windows nt 5.0') > -1) {
            device_os = 'Windows'
            os_version = '2000'
          } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
            device_os = 'Windows'
            os_version = 'XP'
          } else if (userAgent.indexOf('windows nt 6.0') > -1) {
            device_os = 'Windows'
            os_version = 'Vista'
          } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
            device_os = 'Windows'
            os_version = '7'
          } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
            device_os = 'Windows'
            os_version = '8'
          } else if (userAgent.indexOf('windows nt 6.3') > -1) {
            device_os = 'Windows'
            os_version = '8.1'
          } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
            device_os = 'Windows'
            os_version = '10'
          } else {
            device_os = 'Unknown'
            os_version = 'Unknown'
          }
        } else if (userAgent.indexOf('iphone') > -1) {
          device_type = 'Iphone'
          device_os = 'ios'
        } else if (userAgent.indexOf('mac') > -1) {
          device_type = 'Mac'
          device_os = 'macOS'

          if (userAgent.indexOf('mac os x') > 0) {
            var reg = /os x [\d._]*/gi
            var verinfo = userAgent.match(reg)
            var version_info = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
            var arr = version_info.split('.')
            if (arr[0] > 11 && arr[1] > 0) {
              //对12.1以后的版本处理,不包括13.0,
              os_version = arr.join('.')
            } else {
              //12.1以前的版本
              os_version = arr.join('.')
            }
          }
        } else if (
          userAgent.indexOf('x11') > -1 ||
          userAgent.indexOf('unix') > -1 ||
          userAgent.indexOf('sunname') > -1 ||
          userAgent.indexOf('bsd') > -1
        ) {
          device_type = 'Unix'
        } else if (userAgent.indexOf('linux') > -1) {
          if (userAgent.indexOf('android') > -1) {
            device_type = 'Android'
            device_os = 'Android'
          } else {
            device_type = 'Linux'
          }
        } else if (userAgent.indexOf('iPad') > -1) {
          device_type = 'IPad'
          device_os = 'ios'
        } else {
          device_type = 'Unknown'
          device_os = 'Unknown'
        }
        return { device_type, device_os, os_version }
      },

      changeActiveName(list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].menu_type === 'SFE') {
            if (list[i].children[0].menu_type === 'TERRITORY') {
              this.$router.push({
                path: '/territory',
              })
              bus.$emit('inactiveNav', i + '-1')
              break
            } else {
              this.$router.push({
                path: '/organization',
              })
              bus.$emit('inactiveNav', i + '-1')
              break
            }
          } else if (list[i].menu_type === 'CLM') {
            this.$router.push({
              path: '/CLM',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'SALES') {
            this.$router.push({
              path: '/CLM',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'REPORTS') {
            this.$router.push({
              path: '/CLM',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'ACCOUNTS') {
            this.$router.push({
              path: '/CLM',
            })
            bus.$emit('inactiveNav', i + '-1')
            break
          } else if (list[i].menu_type === 'CALENDAR') {
            this.$router.push({
              path: '/calendar/calendarTable',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'SETTINGS') {
            this.$router.push({
              path: '/system/roles',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'CAMPAIGN') {
            this.$router.push({
              path: '/CLM',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'DEVOPS') {
            this.$router.push({
              path: '/systemDevelop/rolesDevelop',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'SERVICE') {
            this.$router.push({
              path: '/systemDevelop/rolesDevelop',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'NETWORK_PROFILE') {
            this.$router.push({
              path: '/Territorymanagement',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'TASK') {
            this.$router.push({
              path: '/task',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'REPORTS') {
            this.$router.push({
              path: '/statement/overview',
            })
            bus.$emit('inactiveNav', i)
            break
          } else if (list[i].menu_type === 'DASHBOARD') {
            this.$router.push({
              path: '/dashboard',
            })
            bus.$emit('inactiveNav', i)
            break
          }
        }
      },
      pageExit() {
        localStorage.setItem('active', 1)
        this.activeName = 'LIBRARY'

        this.$router.push({
          path: '/login',
        })
      },
      async getShow(data) {
        try {
          await http.post('/wapi/login/getShow', data).then((res) => {
            if (res.success == true) {
              this.$store.commit('setClient', res.data)
            }
          })
        } catch (e) {
          //console.log(e);
        }
      },
      handleClickTab(tab, event) {
        if (tab.name === 'code') {
          this.socket()
        }
        if (tab.name === 'phone') {
          this.$refs.ruleFormUser.resetFields()
        } else {
          this.$refs.ruleFormPhone.resetFields()
        }
        this.VerificationText = 0
        if (this.Interval) {
          clearInterval(this.Interval)
        }
      },
      uuid() {
        var s = []
        var hexDigits = '0123456789abcdef'
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = '4'
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
        s[8] = s[13] = s[18] = s[23] = '-'

        this.uuidA = s.join('')
        //console.log(s.join(""), 's.join("")');
        return this.uuidA
      },
      dialogLk() {
        this.uuidA = ''
        this.active = 0
        this.dialogVisible = true
        this.VerificationText = 0
        this.activeNameTab = 'user'
        this.tenants = []
        this.form = {
          username: '',
          password: '',
          phone: '',
          verifyCode: '',
          tenant_id: '',
        }
        if (this.Interval) {
          clearInterval(this.Interval)
        }
      },
      async getTenantsEmail() {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(async () => {
          this.form.tenant_id = ''
          this.formCaptcha.tenant_id = ''
          this.tenants = []
          let para = 'product_id=CRM&tenant_type=CRM&client_id=com.saasyun.web&email=' + this.formVerification.email
          let tenants = await http.post('/yellow_page/getTenantsByEmail', para)

          if (!tenants.success) {
            this.$message.error('租户列表获取失败')
            return false
          }
          //console.log(tenants);

          if (tenants.data.length > 1) {
            this.tenants = tenants.data
          } else if (tenants.data.length === 0) {
            this.formCaptcha.tenant_id = ''
          } else {
            this.formCaptcha.tenant_id = tenants.data[0].tenant_id
          }
          //console.log(this.tenants, 222);
        }, 500)
      },
      //获取租户列表
      async getTenants(type = '') {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(async () => {
          this.form.tenant_id = ''
          this.formCaptcha.tenant_id = ''
          this.tenants = []
          // let para = "product_id=CRM&tenant_type=CRM&client_id=com.saasyun.web&username=" + (type === 'login' ? this.form.phone : this.formVerification.phone)
          let para = 'product_id=CRM&tenant_type=CRM&client_id=com.saasyun.web&username='
          let _paras = {
            product_id: 'CRM',
            tenant_type: 'CRM',
            client_id: 'com.saasyun.web',
            username: '',
          }
          switch (type) {
            case 'login':
              para += this.form.phone
              _paras.username = this.form.phone
              break
            case 'username':
              para += this.form.username
              _paras.username = this.form.username
              break
            default:
              para += this.formVerification.phone
              _paras.username = this.formVerification.phone
          }

          debugger

          // let tenants = await http.post('/yellow_page/getTenantsByUsername', _paras)
          let tenants = await http.post('/yp/tenants/getTenantsByUsername', _paras)

          if (!tenants.success) {
            this.$message.error('租户列表获取失败')
            return false
          }
          if (tenants.data.length > 1) {
            this.tenants = tenants.data
          } else if (tenants.data.length === 0) {
            if (type === 'login') {
              this.form.tenant_id = ''
            } else {
              this.formCaptcha.tenant_id = ''
            }
          } else {
            if (type === 'login' || type === 'username') {
              this.form.tenant_id = tenants.data[0].tenant_id
            } else {
              this.formCaptcha.tenant_id = tenants.data[0].tenant_id
            }
          }
        }, 500)
      },

      async getTenantsLogin(type) {
        this.form.tenant_id = ''
        this.formCaptcha.tenant_id = ''
        this.tenants = []
        // let para = "product_id=CRM&tenant_type=CRM&client_id=com.saasyun.web&username=" + (type === 'login' ? this.form.phone : this.formVerification.phone)
        let para = 'product_id=CRM&tenant_type=CRM&client_id=com.saasyun.web&username='
        let _paras = {
          product_id: 'CRM',
          tenant_type: 'CRM',
          client_id: 'com.saasyun.web',
          username: '',
        }
        switch (type) {
          case 'login':
            para += this.form.phone
            _paras.username = this.form.phone
            break
          case 'username':
            para += this.form.username
            _paras.username = this.form.username
            break
          default:
            para += this.formVerification.phone
            _paras.username = this.formVerification.phone
        }

        // let tenants = await http.post('/yellow_page/getTenantsByUsername', _paras)
        let tenants = await http.post('/yp/tenants/getTenantsByUsername', _paras)

        if (!tenants.success) {
          this.$message.error('租户列表获取失败')
          return false
        }
        if (tenants.data.length > 1) {
          this.tenants = tenants.data
        } else if (tenants.data.length === 0) {
          if (type === 'login') {
            this.form.tenant_id = ''
          } else {
            this.formCaptcha.tenant_id = ''
          }
        } else {
          if (type === 'login' || type === 'username') {
            this.form.tenant_id = tenants.data[0].tenant_id
          } else {
            this.formCaptcha.tenant_id = tenants.data[0].tenant_id
          }
        }

        //console.log(this.form.tenant_id,1)

        this.userLogin3()
      },
      //弹框关闭
      dialogClose() {
        if (this.Interval) {
          clearInterval(this.Interval)
        }
        this.VerificationText = 0
        this.formVerification.email = ''
        this.formVerification.phone = ''
        this.myType = 'phone'
        this.formCaptcha.pass = ''
        this.formCaptcha.checkPass = ''
        this.formCaptcha.validation = ''
        this.tenants = []
        if (this.$refs.formCaptcha) {
          this.$refs.formCaptcha.resetFields()
        }
      },
      //修改密码
      async editPass() {
        let data = {
          tenant_id: this.formCaptcha.tenant_id,
          phone: this.formVerification.phone,
          email: this.formVerification.email,
          pass: this.formCaptcha.pass,
        }
        let res = await http.post('/wapi/v1/editPass', data)
        if (!res.success) {
          this.$message.error(res.message)
          return false
        }
        //console.log(2);
        return true
      },
      //修改密码验证验证码
      async verifyCaptcha() {
        let rule
        this.$refs['formCaptcha'].validate((valid) => {
          if (valid) {
            rule = true
          } else {
            rule = false
            return false
          }
        })
        if (!rule) {
          return false
        }
        // let data = {
        //   captcha: this.formCaptcha.validation,
        //   phone: this.formVerification.phone,
        //   email: this.formVerification.email
        // }
        let data = {}
        let res = {}
        let a = await this.editPass()
        //console.log(1);
        return true
        // if (!this.formVerification.email) {
        //     data = {
        //         sns_app_id: '',
        //         captcha: this.formCaptcha.validation,
        //         phone: this.formVerification.phone,
        //         scope: "16777215",
        //         session_id: this.uuidA,
        //         client_secre: "adcca2be-27d9-4a87-b953-ff64739cce87",
        //         client_id: "com.saasyun.web"
        //     }
        //
        //     res = await http.post('/oauth/verifyCaptchar', data)
        //
        // } else {
        //
        //     data = {
        //         captcha: this.formCaptcha.validation,
        //         email: this.formVerification.email,
        //         session_id: this.uuidA,
        //         product_id: 'CRM',
        //         tenant_type: 'CRM',
        //         client_id: "com.saasyun.web"
        //     }
        //     res = await http.post('/oauth/verifyCaptcharEmail', data)
        // }
        // //console.log(res)
        // if (res.success) {
        //
        // }
        //
        // this.$message.error(res.message)
        // this.VerificationText = 0
        // return false
      },
      async verifyCaptcha2() {
        let data = {}
        let res = {}
        if (!this.formVerification.email) {
          data = {
            sns_app_id: '',
            captcha: this.formCaptcha.validation,
            phone: this.formVerification.phone,
            scope: '16777215',
            session_id: this.uuidA,
            client_secre: 'adcca2be-27d9-4a87-b953-ff64739cce87',
            client_id: 'com.saasyun.web',
          }

          res = await http.post('/oauth/verifyCaptchar', data)
        } else {
          data = {
            captcha: this.formCaptcha.validation,
            email: this.formVerification.email,
            session_id: this.uuidA,
            product_id: 'CRM',
            tenant_type: 'CRM',
            client_id: 'com.saasyun.web',
          }
          res = await http.post('/oauth/verifyCaptcharEmail', data)
        }
        //console.log(res);
        if (res.success) {
          // let a = await this.editPass()
          // //console.log(1)
          return true
        }

        this.$message.error(res.message)
        this.VerificationText = 0
        return false
      },
      //登录验证验证码
      async loginVerifyCaptcha() {
        let data = {}
        let res = {}

        data = {
          sns_app_id: '',
          captcha: this.form.verifyCode,
          phone: this.form.phone,
          scope: '16777215',
          session_id: this.uuidA,
          client_secre: 'adcca2be-27d9-4a87-b953-ff64739cce87',
          client_id: 'com.saasyun.web',
        }

        res = await http.post('/oauth/verifyCaptchar', data)

        if (res.success) {
          return true
        }
        this.$message.error('验证码错误!')
        if (this.Interval) {
          clearInterval(this.Interval)
        }
        this.VerificationText = 0
        return false
      },
      async sendVerification(type = '') {
        this.VerificationText = 0
        if (this.Interval) {
          clearInterval(this.Interval)
        }
        let rule
        this.$refs[type ? 'ruleFormPhone' : 'rulesVerification'].validate((valid) => {
          if (valid) {
            rule = true
          } else {
            rule = false
            return false
          }
        })
        if (!rule) {
          return
        }
        let params = {
          phone: this.formVerification.phone,
          email: this.formVerification.email,
        }
        if (type === 'login') {
          params = {
            phone: this.form.phone,
          }
        }
        // let resUser = await http.post('/wapi/v1/determineUser', params)
        // if (!resUser.success) {
        //   this.$message.error('没有该用户!')
        //   return false;
        // }
        let res
        if (params.phone) {
          let data = {
            client_id: 'com.saasyun.web',
            username: params.phone,
            session_id: this.uuid(),
            code: '+86',
            sns_app_type: 'F',
            tenant_type: 'CRM',
          }
          res = await http.post('/oauth/sendCaptcha', data)
        }
        if (params.email) {
          let data = {
            email: params.email,
            product_id: 'CRM',
            tenant_type: 'CRM',
            session_id: this.uuid(),
          }
          res = await http.post('/oauth/sendVerifyCaptchaEmail', data)
        }

        //console.log(res);
        if (res.success) {
          this.$message.success('验证码发送成功，请注意查收!')
          this.VerificationText = 30
          this.Interval = setInterval(() => {
            --this.VerificationText
            if (this.VerificationText <= 0) {
              clearInterval(this.Interval)
            }
          }, 1000)
        } else {
          this.$message.error(res.message ? res.message : '未知错误')
        }
      },
      onComplete() {
        this.dialogVisible = false
      },
      prev() {
        --this.active
        if (this.active < 0) this.active = 0
      },
      async next() {
        if (!(this.formVerification.phone || this.formVerification.email) && this.active === 1) {
          return
        }

        if (this.active === 1) {
          this.VerificationText = 0
          clearInterval(this.Interval)
          let res = await this.verifyCaptcha2()
          if (!res) {
            return
          }
        }
        if (this.active === 2) {
          this.VerificationText = 0
          clearInterval(this.Interval)
          // let res = await this.verifyCaptcha()
          // if (!res) {
          //     return;
          // }
          let res = await this.verifyCaptcha()
          if (!res) {
            return
          }
        }
        if (this.active++ > 3) this.active = 0
      },
      selectBack(type) {
        this.VerificationText = 0
        if (this.Interval) {
          clearInterval(this.Interval)
        }

        this.formVerification.phone = ''
        this.formVerification.email = ''
        this.formCaptcha.pass = ''
        this.formCaptcha.checkPass = ''
        this.formCaptcha.validation = ''
        if (this.$refs.formCaptcha) {
          this.$refs.formCaptcha.resetFields()
        }

        this.myType = type
      },
      async onIntoThe(item) {
        try {
          let data
          switch (this.SelectTenantType) {
            case 'phone':
              data = {
                phone: this.form.phone || '',
                verifyCode: this.form.verifyCode || '',
                tenant_id: item.tenant_id || '',
              }
              break
            case 'username':
              data = {
                username: this.form.username || '',
                password: this.form.password || '',
                tenant_id: item.tenant_id || '',
              }
              break
          }
          //console.log(data);
          let userObj
          this.loading = true
          let res = await http.post('/wapi/v1/login', data)
          //console.log(res);

          if (res.success) {
            this.obj = userObj = res.data
          } else {
            this.loading = false
            this.$message.error(res.msg)
            return
          }
          if (this.obj.tenant_type && this.obj.tenant_type === 'CRM') {
            // if (this.obj.role === 'clerk') {//clerk、manager、staff、admin
            //     this.error('抱歉！目前仅支持管理人员登录')
            //     this.socket()
            //     return
            // }
            this.$store.commit('setUser', userObj)
            this.rolePage(userObj)
            this.getSysInfo
            this.LoginRecord(userObj) // 登录记录
            this.getParametersList();
            var obj = { index: true }
            this.$store.commit('setStoreChange', obj)

            // 5天主动退出
            // setTimeout(this.pageExit, 432000 * 1000);
          } else {
            this.loading = false
            this.$message.error('用户名或密码错误')
          }
        } catch (err) {
          this.loading = false
          this.error('登录失败')
        }
      },
    },
    updated() {
      // //console.log(this.VerificationText)
    },
  }
</script>
<style lang="scss" module>
  .container {
    padding-top: 100px;
    text-align: center;

    .img {
      width: 200px !important;
      height: 200px !important;
      /*margin-top: 30px;*/
    }

    .btn {
      margin-top: 20px;
    }
  }
</style>
<style>
  .loginFormLk {}

  @media screen and (max-width: 500px) {
    .loginFormLk {
      transform: scale(0.8);
    }
  }

  .loginFormLk .el-tabs__nav-wrap::after {
    height: 0;
  }

  /*.loginFormLk  .el-tabs__item.is-top:nth-child(2) {*/
  /*  padding-left: 20px;*/
  /*}*/
  /*.loginFormLk .el-tabs__item.is-top:last-child{*/
  /*  padding-right: 20px;*/
  /*}*/
  .loginFormLk .el-tabs__header {
    padding: 0 20px;
    width: calc(100% - 40px);
  }

  .textSty .el-form-item__label {
    color: #1d1e1f;
    font-weight: bold;
    text-align: left;
  }

  .verifyCode .el-form-item__content {
    display: flex;
  }

  .loginFormLk .el-input__inner {
    padding-left: 50px;
  }

  .loginFormLk .el-tabs__item {
    font-size: 16px;
  }

  .boxSty {
    margin: 0 auto;
    margin-top: 20px;
    width: 590px;
    height: 85px;
    border: 1px solid #ededed;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .dialogSty {
    border-radius: 5px;
    box-shadow: 0px 1px 13px 7px rgba(0, 0, 0, 0.4);
  }
</style>
<style scoped>
  .loginFormLk>>>.el-button--warning:hover {
    background: #ffb82c;
    border-color: #ffb82c;
    color: #fff;
  }

  .loginFormLk>>>.el-button--warning {
    background: #ff9901;
    border-color: #ff9901;
  }

  .dialogLoginReset>>>.el-button--warning:hover {
    background: #ffb82c;
    border-color: #ffb82c;
    color: #fff;
  }

  .dialogLoginReset>>>.el-button--warning {
    background: #ff9901;
    border-color: #ff9901;
  }

  .loginFormLk>>>.el-tabs__item {
    height: 45px;
  }

  .subjectList>>>.el-step.is-simple .el-step__title {
    font-size: 14px;
  }

  .subjectList>>>.el-button--success {
    background: #7ed321;
    border-color: #7ed321;
  }

  .subjectList>>>.el-button--success:hover {
    background: rgba(126, 211, 33, 0.8);
    border-color: rgba(126, 211, 33, 0.8);
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/pages/login.vue